module.exports = {
  baseURL: 'https://panel-api.nidin.shop/1.0',
  token: 'Nidin_wb_token',
  userId: 'Nidin_wb_user_id',
  roleType: 'Nidin_wb_role_type',
  account: 'Nidin_wb_account',
  web: 'https://order.nidin.shop/',
  bdms: 'https://bdms.nidin.shop/',
  brand: 'nidin'
}



// WEBPACK FOOTER //
// ./src/assets/js/config-prod.js